export default "__VITE_ASSET__D2V$iV8v__"